// Widget Scripts
import ticketButton from './js/widgets/ticketButton.js';
import swiperWidget from './js/widgets/swiperWidget.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import cardWidget from './js/widgets/cardWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Ticket Button Widget
$(document).ready(function () {
  ticketButton();
});

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    swiperWidget();
    multiScheduleFeature();
    cardWidget();
    seoWidget();
    scrollerSponsors();
  });
}
